import { mountLegislature } from './utils/mount-legislature.js';
import { STATE_URL } from './constants.js';
import { called_assembly_races } from './close_races.js';
mountLegislature(
  'uncalled-california-state-assembly',
  STATE_URL,
  'Y',
  called_assembly_races
).catch(console.error);
